import {
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS,
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS,
  GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR,
  GET_MARKETPLACE_SOURCE_STATS,
  GET_MARKETPLACE_SOURCE_STATS_SUCCESS,
  GET_MARKETPLACE_SOURCE_STATS_ERROR,
  GET_MARKETPLACE_AD_GROUP_STATS,
  GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS,
  GET_MARKETPLACE_AD_GROUP_STATS_ERROR,
  GET_MARKETPLACE_DASHBOARD_STATS,
  CANCEL_MARKETPLACE_DASHBOARD_STATS,
  GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS,
  GET_MARKETPLACE_DASHBOARD_STATS_ERROR
} from "./actionTypes";

const initialState = {
  marketplace_agg_campaigns_data: [],
  marketplace_agg_campaigns_loading: false,
  marketplace_agg_campaigns_error: [],
  marketplace_source_stats_data: [],
  marketplace_source_stats_loading: false,
  marketplace_source_stats_error: null,
  marketplace_ad_group_stats_data: [],
  marketplace_ad_group_stats_loading: false,
  marketplace_ad_group_stats_error: null,
  marketplace_dashboard_main_data: [],
  marketplace_dashboard_compare_to_main_data: [],
  marketplace_dashboard_date_ranges: [],
  marketplace_dashboard_campaign_wise_metrics: [],
  marketplace_dashboard_lead_type_wise_metrics: [],
  marketplace_dashboard_state_wise_metrics: [],
  marketplace_dashboard_source_wise_metrics: [],
  marketplace_dashboard_loading: false,
  marketplace_dashboard_error: null
};

const marketplaceStatsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS:
      return {
        ...state,
        marketplace_agg_campaigns_data: [],
        marketplace_agg_campaigns_loading: true,
        marketplace_agg_campaigns_error: null
      }

    case GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_SUCCESS:
      return {
        ...state,
        marketplace_agg_campaigns_data: action.payload,
        marketplace_agg_campaigns_loading: false,
        marketplace_agg_campaigns_error: null
      }

    case GET_AGG_MARKETPLACE_STATS_FOR_CAMPAIGNS_ERROR:
      return {
        ...state,
        marketplace_agg_campaigns_data: [],
        marketplace_agg_campaigns_loading: false,
        marketplace_agg_campaigns_error: action.payload
      }

    case GET_MARKETPLACE_SOURCE_STATS:
      return {
        ...state,
        marketplace_source_stats_data: [],
        marketplace_source_stats_loading: true,
        marketplace_source_stats_error: null
      }

    case GET_MARKETPLACE_SOURCE_STATS_SUCCESS:
      return {
        ...state,
        marketplace_source_stats_data: action.payload,
        marketplace_source_stats_loading: false,
        marketplace_source_stats_error: null
      }

    case GET_MARKETPLACE_SOURCE_STATS_ERROR:
      return {
        ...state,
        marketplace_source_stats_data: [],
        marketplace_source_stats_loading: false,
        marketplace_source_stats_error: action.payload
      }

    case GET_MARKETPLACE_AD_GROUP_STATS:
      return {
        ...state,
        marketplace_ad_group_stats_loading: true,
        marketplace_ad_group_stats_error: null
      }

    case GET_MARKETPLACE_AD_GROUP_STATS_SUCCESS:
      return {
        ...state,
        marketplace_ad_group_stats_data: action.payload,
        marketplace_ad_group_stats_loading: false,
        marketplace_ad_group_stats_error: null
      }

    case GET_MARKETPLACE_AD_GROUP_STATS_ERROR:
      return {
        ...state,
        marketplace_ad_group_stats_loading: false,
        marketplace_ad_group_stats_error: action.payload
      }

    // Clear every payload together when the filter window changes so stale
    // product/date data is never rendered during the next request.
    case GET_MARKETPLACE_DASHBOARD_STATS:
      return {
        ...state,
        marketplace_dashboard_main_data: [],
        marketplace_dashboard_compare_to_main_data: [],
        marketplace_dashboard_date_ranges: [],
        marketplace_dashboard_campaign_wise_metrics: [],
        marketplace_dashboard_lead_type_wise_metrics: [],
        marketplace_dashboard_state_wise_metrics: [],
        marketplace_dashboard_source_wise_metrics: [],
        marketplace_dashboard_loading: true,
        marketplace_dashboard_error: null
      }

    case CANCEL_MARKETPLACE_DASHBOARD_STATS:
      return {
        ...state,
        marketplace_dashboard_loading: false
      }

    case GET_MARKETPLACE_DASHBOARD_STATS_SUCCESS:
      return {
        ...state,
        marketplace_dashboard_main_data: action.payload?.main_data || [],
        marketplace_dashboard_compare_to_main_data:
          action.payload?.compare_to_main_data || [],
        marketplace_dashboard_date_ranges: action.payload?.date_ranges || [],
        marketplace_dashboard_campaign_wise_metrics:
          action.payload?.campaign_wise_metrics || [],
        marketplace_dashboard_lead_type_wise_metrics:
          action.payload?.lead_type_wise_metrics || [],
        marketplace_dashboard_state_wise_metrics:
          action.payload?.state_wise_metrics || [],
        marketplace_dashboard_source_wise_metrics:
          action.payload?.source_wise_metrics || [],
        marketplace_dashboard_loading: false,
        marketplace_dashboard_error: null
      }

    case GET_MARKETPLACE_DASHBOARD_STATS_ERROR:
      return {
        ...state,
        marketplace_dashboard_main_data: [],
        marketplace_dashboard_compare_to_main_data: [],
        marketplace_dashboard_date_ranges: [],
        marketplace_dashboard_campaign_wise_metrics: [],
        marketplace_dashboard_lead_type_wise_metrics: [],
        marketplace_dashboard_state_wise_metrics: [],
        marketplace_dashboard_source_wise_metrics: [],
        marketplace_dashboard_loading: false,
        marketplace_dashboard_error: action.payload
      }

    default:
      return state;
  }
};

export default marketplaceStatsReducer;
